/* eslint-disable max-len, newline-per-chained-call, no-restricted-properties, padded-blocks, prefer-destructuring */

export default {
  data() {
    return {
      projectWorkOrderBillModelValid: true,
      projectWorkOrderBillModel: null,
      projectWorkOrderBillAddModalId: 'projectWorkOrderBillAddModal',
      projectWorkOrderBillEditModalId: 'projectWorkOrderBillEditModal',
      projectWorkOrderBillSchema: {},
    };
  },
  methods: {
    getGrandTotal(workOrder) {
      let lineItemGrandTotal = 0;
      const lineItemTotals = (workOrder.workOrderLineItems || []).map(
        (e) => Math.round(e.quantity * (e.salePrice * 100)),
      );

      if (lineItemTotals.length > 0) {
        lineItemGrandTotal = lineItemTotals.reduce((lineItemSum, lineItemValue) => lineItemSum + lineItemValue);
      }
      /* eslint-disable-next-line */
      lineItemGrandTotal /= Math.pow(10, 2);

      let incentiveGrandTotal = 0;
      const incentiveTotals = (workOrder.workOrderProjectIncentives || []).map(
        (e) => Math.round(e.paymentAmount * 100),
      );

      if (incentiveTotals.length > 0) {
        incentiveGrandTotal = incentiveTotals.reduce((incentiveSum, incentiveValue) => incentiveSum + incentiveValue);
      }
      /* eslint-disable-next-line */
      incentiveGrandTotal /= Math.pow(10, 2);

      return lineItemGrandTotal + incentiveGrandTotal;
    },
    getDistrictOrPartnerTotal(workOrder) {
      let districtOrPartnerTotal = 0;

      const lineItemTotals = (workOrder.workOrderLineItems || []).map(
        (e) => (e.quantity * (e.salePrice * 100) * (e.districtAndPartnerCost * 0.01)),
      );

      if (lineItemTotals.length > 0) {
        districtOrPartnerTotal = lineItemTotals.reduce((lineItemSum, lineItemValue) => lineItemSum + lineItemValue);
      }
      /* eslint-disable-next-line */
      districtOrPartnerTotal /= Math.pow(10, 2);

      let incentiveGrandTotal = 0;
      const incentiveTotals = (workOrder.workOrderProjectIncentives || []).map(
        (e) => Math.round(e.paymentAmount * 100),
      );

      if (incentiveTotals.length > 0) {
        incentiveGrandTotal = incentiveTotals.reduce((incentiveSum, incentiveValue) => incentiveSum + incentiveValue);
      }
      /* eslint-disable-next-line */
      incentiveGrandTotal /= Math.pow(10, 2);

      return districtOrPartnerTotal + incentiveGrandTotal;
    },
    getBillPaymentTotal(bill) {
      if ((!bill.workOrderBillLineItems || bill.workOrderBillLineItems.length === 0)
        && (!bill.workOrderBillIncentivePayments || bill.workOrderBillIncentivePayments.length === 0)) {
        return 0;
      }

      let lineItemBillPaymentTotal = 0.0;
      if (bill.workOrderBillLineItems && bill.workOrderBillLineItems.length > 0) {
        const lineItemBillPaymentTotals = bill.workOrderBillLineItems.map(
          (e) => Math.round(e.quantity * (e.salePrice * 100)),
        );

        lineItemBillPaymentTotal = lineItemBillPaymentTotals.reduce(
          (totalPayment, payment) => totalPayment + payment,
        );
        /* eslint-disable-next-line */
        lineItemBillPaymentTotal /= Math.pow(10, 2);
      }

      let incentivePaymentBillPaymentTotal = 0.0;
      if (bill.workOrderBillIncentivePayments && bill.workOrderBillIncentivePayments.length > 0) {
        const incentivePaymentBillPaymentTotals = bill.workOrderBillIncentivePayments.map(
          (e) => (e.amountBilled * 100),
        );

        incentivePaymentBillPaymentTotal = incentivePaymentBillPaymentTotals.reduce(
          (totalPayment, payment) => totalPayment + payment,
        );
        /* eslint-disable-next-line */
        incentivePaymentBillPaymentTotal /= Math.pow(10, 2);
      }

      return lineItemBillPaymentTotal + incentivePaymentBillPaymentTotal;
    },
    getBillPaymentTotalByFundingSource(bill) {
      if (!bill.workOrderBillLineItems || bill.workOrderBillLineItems.length === 0) return 0;

      const billPaymentTotalsByFundingSource = bill.workOrderBillLineItems.map(
        (e) => {
          const fb = {
            id: e.fundingSourceId,
            amount: Math.round(e.quantity * (e.salePrice * 100)) / Math.pow(10, 2),
          };
          return fb;
        },
      );

      return billPaymentTotalsByFundingSource;
    },
    getApprovedForPaymentTotal(workOrder) {
      const lineItemTotals = (this.projectWorkorderBills || []).filter(
        (e) => (e.workOrderId === workOrder.id) && (e.status === this.config.workOrderBillForm.submitStatus.ApprovedForPayment),
      ).map(
        (e) => e.workOrderBillLineItems,
      ).flat().map(
        (e) => Math.round(e.quantity * (e.salePrice * 100)),
      );

      let approvedForPaymentLineItemTotal = 0;
      if (lineItemTotals.length > 0) {
        approvedForPaymentLineItemTotal = lineItemTotals.reduce((grandTotal, lineItemTotal) => grandTotal + lineItemTotal);
      }

      /* eslint-disable-next-line */
      approvedForPaymentLineItemTotal /= Math.pow(10, 2);

      const incentiveTotals = (this.projectWorkorderBills || []).filter(
        (e) => (e.workOrderId === workOrder.id) && (e.status === this.config.workOrderBillForm.submitStatus.ApprovedForPayment),
      ).map(
        (e) => e.workOrderBillIncentivePayments,
      ).flat().map(
        (e) => Math.round(e.amountBilled * 100),
      );

      let approvedForPaymentIncentiveTotal = 0;
      if (incentiveTotals.length > 0) {
        approvedForPaymentIncentiveTotal = incentiveTotals.reduce((grandTotal, incentiveTotal) => grandTotal + incentiveTotal);
      }

      /* eslint-disable-next-line */
      approvedForPaymentIncentiveTotal /= Math.pow(10, 2);

      return approvedForPaymentLineItemTotal + approvedForPaymentIncentiveTotal;
    },
    getPendingBillApprovalTotal(workOrder) {
      const lineItemTotals = (this.projectWorkorderBills || []).filter(
        (e) => e.workOrderId === workOrder.id && (e.status === this.config.workOrderBillForm.submitStatus.SubmittedForApproval || e.status === this.config.workOrderBillForm.submitStatus.SubmittedForPayment),
      ).map(
        (e) => e.workOrderBillLineItems,
      ).flat().map(
        (e) => Math.round(e.quantity * (e.salePrice * 100)),
      );

      let pendingBillApprovalLineItemTotal = 0;

      if (lineItemTotals.length > 0) {
        pendingBillApprovalLineItemTotal = lineItemTotals.reduce((grandTotal, lineItemTotal) => grandTotal + lineItemTotal);
      }

      /* eslint-disable-next-line */
      pendingBillApprovalLineItemTotal /= Math.pow(10, 2);

      const incentiveTotals = (this.projectWorkorderBills || []).filter(
        (e) => e.workOrderId === workOrder.id && (e.status === this.config.workOrderBillForm.submitStatus.SubmittedForApproval || e.status === this.config.workOrderBillForm.submitStatus.SubmittedForPayment),
      ).map(
        (e) => e.workOrderBillIncentivePayments,
      ).flat().map(
        (e) => Math.round(e.amountBilled * 100),
      );

      let pendingBillApprovalIncentiveTotal = 0;
      if (incentiveTotals.length > 0) {
        pendingBillApprovalIncentiveTotal = incentiveTotals.reduce((grandTotal, incentiveTotal) => grandTotal + incentiveTotal);
      }

      /* eslint-disable-next-line */
      pendingBillApprovalIncentiveTotal /= Math.pow(10, 2);

      return pendingBillApprovalLineItemTotal + pendingBillApprovalIncentiveTotal;
    },
    getRemainingTotal(workOrder) {
      let grandTotal = this.getGrandTotal(workOrder);
      grandTotal = Math.round((grandTotal * 100));

      let approvedForPaymentTotal = this.getApprovedForPaymentTotal(workOrder);
      approvedForPaymentTotal = Math.round((approvedForPaymentTotal * 100));

      let pendingBillApprovalTotal = this.getPendingBillApprovalTotal(workOrder);
      pendingBillApprovalTotal = Math.round((pendingBillApprovalTotal * 100));

      let spentTotal = this.getSpentTotal(workOrder);
      spentTotal = Math.round((spentTotal * 100));

      let remainingTotal = grandTotal - approvedForPaymentTotal - pendingBillApprovalTotal - spentTotal;
      /* eslint-disable-next-line */
      remainingTotal /= Math.pow(10, 2);

      return remainingTotal;
    },
    getSpentTotal(workOrder) {
      if (!workOrder.workOrderBills || workOrder.workOrderBills.length === 0) return 0;

      let spentLineItemTotal = 0;
      const paidWorkOrderBillLineItems = workOrder.workOrderBills.filter(
        (e) => e.status === this.config.workOrderBillForm.submitStatus.Paid,
      ).map(
        (e) => e.workOrderBillLineItems,
      ).flat();

      const paidWorkOrderBillLineItemTotals = paidWorkOrderBillLineItems.map((e) => Math.round(e.itemCost * 100));
      if (paidWorkOrderBillLineItemTotals.length > 0) {
        spentLineItemTotal = paidWorkOrderBillLineItemTotals.reduce((a, b) => a + b);
      }

      /* eslint-disable-next-line */
      spentLineItemTotal /= Math.pow(10, 2);

      let spentIncentiveTotal = 0;
      const paidWorkOrderBillIncentives = workOrder.workOrderBills.filter(
        (e) => e.status === this.config.workOrderBillForm.submitStatus.Paid,
      ).map(
        (e) => e.workOrderBillIncentivePayments,
      ).flat();

      const paidWorkOrderBillIncentiveTotals = paidWorkOrderBillIncentives.map((e) => Math.round(e.amountBilled * 100));
      if (paidWorkOrderBillIncentiveTotals.length > 0) {
        spentIncentiveTotal = paidWorkOrderBillIncentiveTotals.reduce((a, b) => a + b);
      }

      /* eslint-disable-next-line */
      spentIncentiveTotal /= Math.pow(10, 2);

      return spentLineItemTotal + spentIncentiveTotal;
    },
    isWorkOrderBillingComplete(workOrder) {
      if (!workOrder.workOrderLineItems || workOrder.workOrderLineItems == null) return false;
      if (!workOrder.workOrderProjectIncentives || workOrder.workOrderProjectIncentives == null) return false;
      const workOrderLineItemsBillingComplete = workOrder.workOrderLineItems.filter((workOrderLineItem) => workOrderLineItem.billingComplete === true);
      const isWorkOrderLineItemBillingComplete = workOrder.workOrderLineItems.length === workOrderLineItemsBillingComplete.length;
      const workOrderIncentivesBillingComplete = workOrder.workOrderProjectIncentives.filter((woip) => woip.paymentDate !== null);
      const isWorkOrderIncentiveBillingComplete = workOrder.workOrderProjectIncentives.length === workOrderIncentivesBillingComplete.length;
      return isWorkOrderLineItemBillingComplete && isWorkOrderIncentiveBillingComplete;
    },
    isWorkOrderFundingComplete(workOrder) {
      if (workOrder.status !== 'Accepted') return true;
      if ((!workOrder.workOrderLineItems || workOrder.workOrderLineItems === null || workOrder.workOrderLineItems.length === 0)
        && (!workOrder.workOrderProjectIncentives || workOrder.workOrderProjectIncentives === null || workOrder.workOrderProjectIncentives.length === 0)) {
        return true;
      }
      const workOrderLineItemIds = workOrder.workOrderLineItems.map((e) => e.workOrderLineItemId);
      const lineItemFundingSourceWorkOrderLineItemIds = this.projectWorkorderLineItemFundingSources.map((e) => e.workOrderLineItemId);
      const invalidWorkOrderLineItemIds = workOrderLineItemIds.filter((e) => !lineItemFundingSourceWorkOrderLineItemIds.includes(e));
      return invalidWorkOrderLineItemIds.length === 0;
    },
    isLineItemAddDisabled(workOrder) {
      const isLineItemAddDisabled = (workOrder.status === 'Completed');
      return isLineItemAddDisabled;
    },
    isIncentivePaymentAddDisabled(workOrder) {
      const isIncentivePaymentAddDisabled = (workOrder.status === 'Completed');
      return isIncentivePaymentAddDisabled;
    },
    isLineItemBillingCompleteCheckboxDisabled(workOrder) {
      const disabled = (workOrder.status === 'Completed');
      console.log('disabled: ', disabled);
      return disabled;
    },
    isBillAddDisabled(workOrder) {
      const isBillAddDisabled = workOrder.status !== 'Accepted' || !this.isWorkOrderFundingComplete(workOrder) || this.isWorkOrderBillingComplete(workOrder);
      return isBillAddDisabled;
    },
    async loadProjectWorkorderBills() {

      await this.$store.dispatch(
        'Project/getProjectWorkorderBills',
        this.projectWorkorders.map((e) => e.id),
      );

      const workOrderBillLineItems = this.projectWorkorderBills.map((e) => e.workOrderBillLineItems).flat();

      workOrderBillLineItems.forEach((e) => {

        const workOrderBill = this.projectWorkorderBills.find((item) => item.id === e.workOrderBillId);
        const workOrder = this.projectWorkorders.find((item) => item.id === workOrderBill.workOrderId);
        const workOrderLineItem = workOrder.workOrderLineItems.find((item) => item.workOrderLineItemId === e.workOrderLineItemId);

        if (workOrderLineItem && workOrderLineItem != null) {
          e.lineItemProductName = workOrderLineItem.productName;
          e.lineItemProductUnit = workOrderLineItem.productUnit;
          e.lineItemQuantity = workOrderLineItem.quantity;
        }

        let itemCost = Math.round(e.quantity * (e.salePrice * 100));
        itemCost /= Math.pow(10, 2);

        e.itemCost = itemCost;

        const workOrderLineItemIds = workOrder.workOrderLineItems.map((item) => item.workOrderLineItemId);
        const workOrderLineItemFundingSources = this.projectWorkorderLineItemFundingSources.filter((item) => workOrderLineItemIds.includes(item.workOrderLineItemId));
        const fundingSourceIds = workOrderLineItemFundingSources.map((item) => (item.fundingSourceId));

        e.fundingSourceOptions = this.fundingSources.filter(
          (item) => fundingSourceIds.includes(item.recorD_ID),
        ).map(
          (item) => ({ value: item.recorD_ID, text: item.recorD_NAME }),
        ).sort(
          (a, b) => a.text.localeCompare(b.text),
        );

      });

      this.projectWorkorders.map((e) => e.id).forEach((workorderId) => {
        const workorder = this.projectWorkorders.find((item) => item.id === workorderId);
        workorder.workOrderBills = this.projectWorkorderBills.filter((item) => item.workOrderId === workorderId);
      });

    },
    onProjectWorkOrderBillAddClick(workOrderId) {
      const workOrder = this.projectWorkorders.find((e) => e.id === workOrderId);
      const workOrderBills = workOrder.workOrderBills ?? [];
      const workOrderLineItemIds = workOrder.workOrderLineItems.map((item) => item.workOrderLineItemId);
      const workOrderLineItemFundingSources = this.projectWorkorderLineItemFundingSources.filter((item) => workOrderLineItemIds.includes(item.workOrderLineItemId));
      const fundingSourceIds = workOrderLineItemFundingSources.map((item) => (item.fundingSourceId));

      const fundingSourceOptions = this.fundingSources.filter(
        (item) => fundingSourceIds.includes(item.recorD_ID),
      ).map(
        (item) => ({ value: item.recorD_ID, text: item.recorD_NAME }),
      ).sort(
        (a, b) => a.text.localeCompare(b.text),
      );

      const billingCompleteWorkOrderLineItemIds = workOrder.workOrderLineItems.filter((e) => e.billingComplete === true).map((e) => e.workOrderLineItemId);

      const unbilledWorkOrderLineItems = workOrder.workOrderLineItems.filter((e) => !billingCompleteWorkOrderLineItemIds.includes(e.workOrderLineItemId));

      const workOrderBillLineItems = unbilledWorkOrderLineItems.map((e) => {

        const workOrderLineItemFundingSource = workOrderLineItemFundingSources.find((item) => item.workOrderLineItemId === e.workOrderLineItemId);

        const previousBills = workOrderBills.filter(
          (item) => item.status !== this.config.workOrderBillForm.submitStatus.Voided,
        ).map(
          (item) => item.workOrderBillLineItems,
        ).flat().filter(
          (item) => item.workOrderLineItemId === e.workOrderLineItemId,
        );

        let lineItemQuantityBilledToDate = 0;

        if (previousBills.length > 0) {
          lineItemQuantityBilledToDate = previousBills.map((item) => item.quantity).reduce((totalQuantity, quantity) => totalQuantity + quantity);
        }

        const workOrderBillLineItem = {
          id: null,
          workOrderBillId: null,
          workOrderLineItemId: e.workOrderLineItemId,
          fundingSourceId: workOrderLineItemFundingSource.fundingSourceId,
          fundingSourceOptions,
          quantity: 0,
          billingComplete: false,
          lineItemProductName: e.productName,
          lineItemProductUnit: e.productUnit,
          salePrice: e.salePrice,
          lineItemQuantity: e.quantity,
          lineItemQuantityBilledToDate,
        };

        return workOrderBillLineItem;
      });

      const workOrderBillIncentives = workOrderBills.filter((e) => e.status !== 'Void').map((e) => e.workOrderBillIncentivePayments).flat();
      const workOrderBillIncentivePaymentIds = workOrderBillIncentives.map((e) => e.workOrderIncentivePaymentId);
      const unbilledWorkOrderIncentivePayments = workOrder.workOrderProjectIncentives.filter((e) => !workOrderBillIncentivePaymentIds.includes(e.id));

      const workOrderBillIncentivePayments = unbilledWorkOrderIncentivePayments.map((woip) => {
        const projectIncentivePayment = this.projectIncentivePayments.find((ip) => ip.id === woip.projectIncentivePaymentId);

        const workOrderBillIncentive = {
          id: woip.id,
          paymentAmount: woip.paymentAmount,
          paymentDate: woip.paymentDate,
          projectIncentivePaymentId: woip.projectIncentivePaymentId,
          dateDue: projectIncentivePayment.dateDue,
          datePaid: projectIncentivePayment.datePaid,
          fundingSourceId: projectIncentivePayment.fundingSourceId,
          incentiveType: projectIncentivePayment.incentiveType.name,
          amountBilled: woip.paymentAmount,
          billSelected: false,
        };

        return workOrderBillIncentive;
      });

      const workOrderTotal = this.getWorkorderTotal(workOrder);
      const otherBillsTotal = this.getOtherBillsTotal(workOrder);

      this.projectWorkOrderBillModel = {
        workOrderId,
        projectId: parseInt(this.$route.params.id, 10),
        billIdentifier: null,
        billDate: null,
        receivedDate: null,
        status: this.config.workOrderBillForm.submitStatus.Received,
        notes: null,
        workOrderTotal,
        otherBillsTotal,
        workOrderBillLineItems,
        workOrderBillIncentivePayments,
      };

      this.projectWorkOrderBillSchema = this.getProjectWorkOrderBillSchema();
      this.validateProjectWorkOrderBillRequiredFields([]);
      this.$bvModal.show(this.projectWorkOrderBillAddModalId);
    },
    onProjectWorkOrderBillAddOkClick() {
      (async () => {
        this.$bvModal.hide(this.projectWorkOrderBillAddModalId);

        const validNumberOfLineItems = (this.projectWorkOrderBillModel.workOrderBillLineItems && this.projectWorkOrderBillModel.workOrderBillLineItems.length > 0);
        const validNumberOfIncentives = (this.projectWorkOrderBillModel.workOrderBillIncentivePayments && this.projectWorkOrderBillModel.workOrderBillIncentivePayments.length > 0);
        if (!validNumberOfLineItems && !validNumberOfIncentives) return;

        const workOrderBillLineItems = this.projectWorkOrderBillModel.workOrderBillLineItems.filter((e) => e.quantity !== 0 && e.quantity !== '' && e.quantity !== '0');
        const workOrderBillIncentives = this.projectWorkOrderBillModel.workOrderBillIncentivePayments.filter((e) => e.billSelected === true);

        if (workOrderBillLineItems.length > 0 || workOrderBillIncentives.length > 0) {
          await this.$store.dispatch('Workorder/setFormLoading', true);
          const model = { ...this.projectWorkOrderBillModel };
          delete model.workOrderBillLineItems;
          delete model.workOrderBillIncentivePayments;
          await this.$store.dispatch('Project/postProjectWorkorderBill', model);
          const workOrderBillId = this.projectWorkorderBill.id;
          await this.$store.dispatch('Project/postProjectWorkorderBillLineItems', { workOrderBillId, workOrderBillLineItems });
          await this.$store.dispatch('Project/postProjectWorkorderBillIncentivePayments', { workOrderBillId, workOrderBillIncentives });
          await this.$store.dispatch('Workorder/setFormLoading', false);
          this.load();
        }
      })();
    },
    onProjectWorkOrderBillAddCancelClick() {
      this.$bvModal.hide(this.projectWorkOrderBillAddModalId);
    },
    onProjectWorkOrderBillEditClick(workOrderId, workOrderBillId) {
      const workOrder = this.projectWorkorders.find((e) => e.id === workOrderId);
      let workOrderBill = workOrder.workOrderBills.find((e) => e.id === workOrderBillId);
      workOrderBill = JSON.parse(JSON.stringify(workOrderBill));

      workOrderBill.workOrderBillLineItems.forEach((e, index) => {

        const previousBills = workOrder.workOrderBills.filter(
          (item) => item.status !== this.config.workOrderBillForm.submitStatus.Voided,
        ).map(
          (item) => item.workOrderBillLineItems,
        ).flat().filter(
          (item) => item.workOrderLineItemId === e.workOrderLineItemId && item.id !== e.id,
        );

        let lineItemQuantityBilledToDate = 0;

        if (previousBills.length > 0) {
          lineItemQuantityBilledToDate = previousBills.map((item) => item.quantity).reduce((totalQuantity, quantity) => totalQuantity + quantity);
        }

        workOrderBill.workOrderBillLineItems[index].lineItemQuantityBilledToDate = lineItemQuantityBilledToDate;
      });

      workOrderBill.workOrderTotal = this.getWorkorderTotal(workOrder);
      workOrderBill.otherBillsTotal = this.getOtherWorkOrderBillTotal(workOrder, workOrderBill);

      const workOrderBillIncentivePayments = workOrderBill.workOrderBillIncentivePayments.map((wobi) => {
        const wopi = workOrder.workOrderProjectIncentives.find((e) => e.id === wobi.workOrderIncentivePaymentId);
        const pi = this.projectIncentivePayments.find((e) => e.id === wopi.projectIncentivePaymentId);
        const ip = {
          amountBilled: wobi.amountBilled,
          fundingSourceId: wobi.fundingSourceId,
          id: wobi.id,
          workOrderBillId: wobi.workOrderBillId,
          workOrderIncentivePaymentId: wobi.workOrderIncentivePaymentId,
          incentiveType: pi.incentiveType.name,
          paymentAmount: wopi.paymentAmount,
        };

        return ip;
      });

      workOrderBill.workOrderBillIncentivePayments = workOrderBillIncentivePayments;
      this.projectWorkOrderBillModel = workOrderBill;

      this.projectWorkOrderBillSchema = this.getProjectWorkOrderBillSchema();
      this.validateProjectWorkOrderBillRequiredFields([]);

      this.$bvModal.show(this.projectWorkOrderBillEditModalId);
    },
    onProjectWorkOrderBillEditOkClick() {
      (async () => {
        await this.$store.dispatch('Workorder/setFormLoading', true);

        this.$bvModal.hide(this.projectWorkOrderBillEditModalId);

        const model = { ...this.projectWorkOrderBillModel };
        delete model.workOrderBillLineItems;
        delete model.workOrderBillIncentivePayments;

        await this.$store.dispatch('Project/putProjectWorkorderBill', model);

        if (this.projectWorkOrderBillModel.workOrderBillLineItems != null && this.projectWorkOrderBillModel.workOrderBillLineItems.length > 0) {
          await this.$store.dispatch('Project/putProjectWorkorderBillLineItems', this.projectWorkOrderBillModel.workOrderBillLineItems);
        }

        if (this.projectWorkOrderBillModel.workOrderBillIncentivePayments != null && this.projectWorkOrderBillModel.workOrderBillIncentivePayments.length > 0) {
          await this.$store.dispatch('Project/putProjectWorkorderBillIncentivePayments', this.projectWorkOrderBillModel.workOrderBillIncentivePayments);
        }

        await this.$store.dispatch('Workorder/setFormLoading', false);
        this.load();
      })();
    },
    onProjectWorkOrderBillEditCancelClick() {
      this.$bvModal.hide(this.projectWorkOrderBillEditModalId);
    },
    onProjectWorkOrderBillValidated(isValid, errors) {
      if (!isValid) {
        const invoiceNumberErrorIndex = errors.findIndex((e) => e.field.id === 'invoiceNumber');
        if (invoiceNumberErrorIndex >= 0) {
          const invoiceNumberError = errors[invoiceNumberErrorIndex];
          if (invoiceNumberError.error.startsWith('The length of text is too big!')) {
            this.projectWorkOrderBillModel.billIdentifier = this.projectWorkOrderBillModel.billIdentifier.slice(0, 50);
            errors.splice(invoiceNumberErrorIndex, 1);
          }
        }
      }

      const billDateValidationErrorMessage = 'Bill Date cannot be after Received Date!';
      const billDateErrorIndex = errors.findIndex((e) => e.field.id === 'billDate' && e.error === billDateValidationErrorMessage);
      const billDateError = errors[billDateErrorIndex];
      if (billDateError) {
        errors.splice(billDateErrorIndex, 1);
      }

      if (!this.validateBillDateIsPriorToReceivedDate()) {
        const billDateFieldIndex = this.projectWorkOrderBillSchema.fields.findIndex((e) => e.id === 'billDate');
        const billDateField = this.projectWorkOrderBillSchema.fields[billDateFieldIndex];
        errors.push({
          error: billDateValidationErrorMessage,
          field: billDateField,
        });
      }

      this.projectWorkOrderBillModelValid = isValid;
      this.validateProjectWorkOrderBillRequiredFields(errors || []);
    },
    onBillSubmitForApprovalClick(bill) {
      this.submitForApprovalBill = bill;
      this.$bvModal.show('submitBillForApprovalModal');
    },
    onBillSubmitForApprovalClickOk() {
      this.onBillPutStatusClick(this.submitForApprovalBill.id, this.config.workOrderBillForm.submitStatus.SubmittedForApproval);
    },
    onBillSubmitForPaymentClick(bill) {
      this.submitForPaymentBill = bill;
      this.$bvModal.show('submitBillForPaymentModal');
    },
    onBillSubmitForPaymentClickOk() {
      this.onBillPutStatusClick(this.submitForPaymentBill.id, this.config.workOrderBillForm.submitStatus.SubmittedForPayment);
    },
    onBillApproveClick(bill) {
      this.approveBill = bill;
      this.$bvModal.show('approveBillModal');
    },
    onBillApproveClickOk() {
      this.onBillPutStatusClick(this.approveBill.id, this.config.workOrderBillForm.submitStatus.ApprovedForPayment);
    },
    onBillVoidClick(bill) {
      this.voidBill = bill;
      this.$bvModal.show('voidBillModal');
    },
    onBillVoidClickOk() {
      this.onBillPutStatusClick(this.voidBill.id, this.config.workOrderBillForm.submitStatus.Voided);
    },
    onBillPaidClick(bill) {
      this.paidBill = bill;
      this.$bvModal.show('paidBillModal');
    },
    onBillPaidClickOk() {
      this.onBillPutStatusClick(this.paidBill.id, this.config.workOrderBillForm.submitStatus.Paid);
      window.location.href = `mailto:${this.project.projectManager.emailAddress}?subject=Bill(s) Paid&body=${this.project.projectName}: ${window.location.href}`;
    },
    async onBillPutStatusClick(id, status) {
      await this.$store.dispatch('Workorder/setFormLoading', true);
      await this.$store.dispatch('Project/putProjectWorkorderBillStatus', { id, status });
      await this.$store.dispatch('Workorder/setFormLoading', false);
      this.load();
    },
    validateProjectWorkOrderBillRequiredFields(errors) {
      this.projectWorkOrderBillModelValid = true;
      if (this.projectWorkOrderBillModel.billIdentifier === null || this.projectWorkOrderBillModel.billIdentifier.length === 0 || this.projectWorkOrderBillModel.billIdentifier.length > 50) this.projectWorkOrderBillModelValid = false;
      if (this.projectWorkOrderBillModel.billDate === null) this.projectWorkOrderBillModelValid = false;
      if (this.projectWorkOrderBillModel.receivedDate === null) this.projectWorkOrderBillModelValid = false;
      if (this.projectWorkOrderBillModel.notes != null && this.projectWorkOrderBillModel.notes.length > 75) this.projectWorkOrderBillModelValid = false;
      const lineItemsBilled = this.projectWorkOrderBillModel.workOrderBillLineItems.filter((e) => e.quantity !== 0 && e.quantity !== '' && e.quantity !== '0').length;
      const incentivesBilled = this.projectWorkOrderBillModel.workOrderBillIncentivePayments.filter((e) => e.billSelected === true).length;
      if ((lineItemsBilled === 0) && (incentivesBilled === 0)) this.projectWorkOrderBillModelValid = false;

      if (errors && errors.length > 0) this.projectWorkOrderBillModelValid = false;
    },
    validateBillableRemainingIsNotOverTwentyPercent() {
      let overTwentyPercent = false;

      const workOrderTotal = this.projectWorkOrderBillModel.workOrderTotal;
      const workOrderBillTotal = this.projectWorkOrderBillModel.otherBillsTotal + this.getBillPaymentTotal(this.projectWorkOrderBillModel);
      const percent = (workOrderBillTotal / workOrderTotal);

      if (percent > 1.2) {
        overTwentyPercent = true;
      }

      return overTwentyPercent;
    },
    validateBillDateIsPriorToReceivedDate() {
      const billDate = this.projectWorkOrderBillModel.billDate;
      if (!billDate) return true;

      const receivedDate = this.projectWorkOrderBillModel.receivedDate;
      if (!receivedDate) return true;

      return billDate <= receivedDate;
    },
    restrictQuantity(item, event) {
      if (item.quantity && item.quantity != null && (item.quantity.indexOf('.') >= 0)) {
        /* eslint-disable-next-line no-param-reassign */
        item.quantity = item.quantity.match(/^\d*\.?\d{0,2}/)[0];
        event.preventDefault();
      }
      this.validateProjectWorkOrderBillRequiredFields([]);
    },
    restrictSalePrice(item, event) {
      if (item.salePrice && item.salePrice != null && (item.salePrice.indexOf('.') >= 0)) {
        /* eslint-disable-next-line no-param-reassign */
        item.salePrice = item.salePrice.match(/^\d*\.?\d{0,2}/)[0];
        event.preventDefault();
      }
      this.validateProjectWorkOrderBillRequiredFields([]);
    },
  },
};
